import PreviewResultsTable from './PreviewResultsTable';

export default PreviewResultsTable;
